import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLocalCart } from '../context/CartContext';
import { useBag, resolveLines, clearBag } from './bag';
import { useProductsByIds } from './catalogApi';

/** The bag joined to its products: { bag, lines, buyable, subtotal, blocked, loading, products }. */
export function useBagLines() {
  const bag = useBag();
  const { products, loading } = useProductsByIds(bag.map(l => l.productId));
  const lines = resolveLines(bag, products);
  const buyable = lines.filter(l => !l.problem);
  return {
    bag, lines, buyable, products, loading,
    subtotal: buyable.reduce((sum, l) => sum + l.lineTotal, 0),
    blocked: !loading && lines.some(l => l.problem),
  };
}

/** Until checkout is built (phase 2), the bag ends in the existing quote request: its lines
 *  move into the quote cart (CartContext, page /cart) and the bag empties. */
export function useSendBagToQuote() {
  const { addToCart, updateQuantity, cartItems } = useLocalCart();
  const navigate = useNavigate();
  return useCallback((buyable) => {
    buyable.forEach(l => {
      const cartKey = l.variant ? `${l.product.id}-v${l.variant.id}` : String(l.product.id);
      const already = cartItems.find(i => (i._cartKey || String(i.id)) === cartKey)?.quantity || 0;
      addToCart(l.product, l.variant || null);
      updateQuantity(cartKey, already + l.quantity);
    });
    clearBag();
    navigate('/cart');
  }, [addToCart, updateQuantity, cartItems, navigate]);
}
